module.exports = __webpack_public_path__ + "img/credit_card_color.38039333.svg";